import axiosRequest from '@/utils/request'

const http = {
  get: (url, params = {}, options = {}) => {
    const finalParams = {}
    for (const key in params) {
      if (params[key] !== '' && params[key] !== null) {
        finalParams[key] = params[key]
      }
    }
    return axiosRequest({
      url: url,
      method: 'get',
      params: finalParams
    })
  },
  put: (url, data, options = {}) => {
    return axiosRequest({
      url: url,
      method: 'put',
      data: data
    })
  },
  post: (url, data = {}, options = {}) => {
    return axiosRequest({
      url: url,
      method: 'post',
      data: data
    })
  },
  delete: (url, data = {}, options = {}) => {
    return axiosRequest({
      url: url,
      method: 'delete'
    })
  }
  // 静态没有loading的
  // silent: (method, url, data) => {
  //   return new Promise((resolve, reject) => {
  //     axios({
  //       headers: {
  //         Authorization: getStorage('accessToken') ? 'Bearer ' + getStorage('accessToken') : ''
  //       },
  //       method: method,
  //       url: process.env.VUE_APP_BASE_API + url,
  //       data: data
  //     })
  //       .then(response => {
  //         const res = response.data
  //         if (res.code !== '200') {
  //           reject(res)
  //           return
  //         } else {
  //           resolve(res)
  //         }
  //       })
  //       .catch(res => {
  //         console.log('静默请求出错了')
  //         reject()
  //       })
  //   })
  // }
}
export default http
